var YTIMES = window.YTIMES || {};
document.documentElement.classList.remove('no-js');

let ytimesFanal_swipers = [];

YTIMES.jsPack = {};

YTIMES.jsPack.cssFiles = [];
YTIMES.jsPack.jsFiles = [];

YTIMES.jsPack.loadEnqueuedFiles = function () {
	if (document.getElementById('deferredCSS')) {
		let deferredCSS = document.getElementById('deferredCSS').textContent.split(';');
		deferredCSS.map(function (url) {
			if(url != '')
				YTIMES.jsPack.enqueueCssFile(url);
		});
	}
	if (document.getElementById('deferredJS')) {
		let deferredJS = document.getElementById('deferredJS').textContent.split(';');
		deferredJS.map(function (url) {
			if(url != '')
				YTIMES.jsPack.enqueueJsFile(url);
		});
	}

    YTIMES.jsPack.cssFiles.forEach(function (url) {
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = url;
        document.getElementsByTagName("head")[0].appendChild(link);

    });
	function loadScriptSequentially(urls) {
		if (urls.length === 0) return; // Stop when no more URLs
	
		var script = document.createElement("script");
		script.type = "text/javascript";
		script.defer = true;
		script.src = urls[0]; // Load the first URL
	
		script.onload = function() {
			// Remove the loaded URL from the list
			urls.shift();
			// Recursively load the next script
			loadScriptSequentially(urls);
		};
	
		document.getElementsByTagName("head")[0].appendChild(script);
	}
	
	// Start loading scripts sequentially
	loadScriptSequentially(YTIMES.jsPack.jsFiles.slice());	
};

YTIMES.jsPack.enqueueCssFile = function (url) {
    YTIMES.jsPack.cssFiles.push(url);
};

YTIMES.jsPack.enqueueJsFile = function (url) {
    YTIMES.jsPack.jsFiles.push(url);
};

YTIMES.jsPack.handleInteraction = function() {
    function interactionHandler() {
		window.clearTimeout(YTIMES.jsPack.interactionTimeout);
        document.body.classList.add('interaction');

        window.removeEventListener('scroll', interactionHandler, { passive: true });
        window.removeEventListener('mousewheel', interactionHandler, { passive: true });
        window.removeEventListener('mousemove', interactionHandler, { passive: true });
        window.removeEventListener('click', interactionHandler, { passive: true });
        window.removeEventListener('keydown', interactionHandler, { passive: true });
        window.removeEventListener('touchstart', interactionHandler, { passive: true });
        YTIMES.jsPack.loadEnqueuedFiles();
    }
        
    window.addEventListener('scroll', interactionHandler, { passive: true });
    window.addEventListener('mousewheel', interactionHandler, { passive: true });
    window.addEventListener('mousemove', interactionHandler, { passive: true });
    window.addEventListener('click', interactionHandler, { passive: true });
    window.addEventListener('keydown', interactionHandler, { passive: true });
    window.addEventListener('touchstart', interactionHandler, { passive: true });
	YTIMES.jsPack.interactionTimeout = window.setTimeout(interactionHandler, 6000);
}

YTIMES.jsPack.initLazyImages = function() {
    // Check if Intersection Observer is supported
    if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    const card = entry.target;
                    const lazyImage = card.querySelector('img[data-src]');
                    
                    if (lazyImage) {
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImage.removeAttribute('data-src');
                        
                        // Optional: Add a class when image is loaded
                        lazyImage.onload = function() {
                            lazyImage.classList.add('loaded');
                        };
                    }
                    
                    // Stop observing this card since we've processed it
                    observer.unobserve(card);
                }
            });
        }, {
            // Load images when they're 50px away from entering the viewport
            rootMargin: '50px 0px',
            threshold: 0.01
        });

        // Observe all card elements
        const cards = document.querySelectorAll('.card');
        cards.forEach(function(card) {
            imageObserver.observe(card);
        });
    } else {
        // Fallback for older browsers - load all images immediately
        const lazyImages = document.querySelectorAll('.card img[data-src]');
        lazyImages.forEach(function(img) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
        });
    }
};

function GetSBCookie(name) {
	var start = document.cookie.indexOf(name + "=");
	var len = start + name.length + 1;
	if ((!start) && (name != document.cookie.substring(0, name.length))) {
		return null;
	}
	if (start == -1) return null;
	var end = document.cookie.indexOf(";", len);
	if (end == -1) end = document.cookie.length;
	return unescape(document.cookie.substring(len, end));
}
function SetSBCookie(name, value, expires, path, domain, secure) {
	var today = new Date();
	today.setTime(today.getTime());
	if (expires && typeof (expires) == 'number') {
		expires = expires * 1000 * 60 * 60 * 24;
	}
	var expires_date;
	if (typeof (expires) == 'number')
		expires_date = new Date(today.getTime() + (expires));
	else
		expires_date = expires;

	document.cookie = name + "=" + escape(value) +
		((expires) ? ";expires=" + expires_date.toGMTString() : "") + //expires.toGMTString()
		((path) ? ";path=" + path : "") +
		((domain) ? ";domain=" + domain : "") +
		((secure) ? ";secure" : "");
}

function DeleteSBCookie(name, path, domain) {
	if (GetSBCookie(name)) document.cookie = name + "=" +
		((path) ? ";path=" + path : "") +
		((domain) ? ";domain=" + domain : "") +
		";expires=Thu, 01-Jan-1970 00:00:01 GMT";
}

document.addEventListener("DOMContentLoaded", function () {
    YTIMES.jsPack.handleInteraction();

	document.body.prepend(document.querySelector('.jump-to-main-content'));

    function viewport() {
        var e = window,
            a = "inner";
        if (!("innerWidth" in window)) {
            a = "client";
            e = document.documentElement || document.body;
        }
        return {
            width: e[a + "Width"],
            height: e[a + "Height"],
        };
    }
    
    // function setEqualHeight() {
    //     const sliders = document.querySelectorAll('.slider');
    //     sliders.forEach(slider => {
    //         const slides = slider.querySelectorAll('.slick-slide');
    //         let maxHeight = 0;
    
    //         // Reset heights
    //         slides.forEach(slide => {
    //             slide.style.height = 'auto';
    //             const slideHeight = slide.offsetHeight;
    //             if (slideHeight > maxHeight) {
    //                 maxHeight = slideHeight;
    //             }
    //         });
    
    //         // Set all slides to the maximum height
    //         slides.forEach(slide => {
    //             slide.style.height = `${maxHeight}px`;
    //         });    
    //     })
    // }

    // setEqualHeight();
    // window.addEventListener('resize', setEqualHeight, { passive: true });
});